import { ColorDot } from 'components/gruenland/atoms/colors/ColorDot';
import { colorCodeToRgb } from 'lib/colors';

type Props = {
  as?: 'div' | 'button';
  className?: string;
  colourGroupCode: string;
  active?: boolean;
  disableHover?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

export const ColorGroupCodeDot: React.FC<Props> = ({
  as = 'button',
  className,
  colourGroupCode,
  active = false,
  disableHover = false,
  onClick,
}) => (
  <ColorDot
    as={as}
    className={className}
    color={colorCodeToRgb(colourGroupCode)}
    active={active}
    disableHover={disableHover}
    onClick={onClick}
  />
);
